import React from "react";
import { useTranslation } from "react-i18next";
import { RightDrawer } from "../../utils/PMTableView/RightDrawer";

const DOCS = {
  offer: "/docs/modules/OFFER.md",
  calculations: "/docs/modules/OFFER_CALCULATIONS.md",
  documentStructure:
    "/docs/modules/offers/design/05-document-structure.md",
  screenSpec: "/docs/modules/offers/design/02-screen-specifications.md",
};

function HelpSection({ title, children }) {
  return (
    <section className="mb-5">
      <h3 className="text-[13px] font-bold text-slate-900">{title}</h3>
      <div className="mt-1.5 space-y-2 text-[13px] leading-relaxed text-slate-600">
        {children}
      </div>
    </section>
  );
}

function DocLink({ href, label }) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="inline-flex text-[12.5px] font-semibold text-[#1463C7] hover:underline"
    >
      {label} →
    </a>
  );
}

/**
 * In-app Offer help — explains Kalkyle vs Tilbudslinjer, Dokument vs Vedlegg,
 * Revisjoner / Godkjenning / Historikk, and group numbering. Links to docs.
 */
export default function OfferHelpDrawer({ open, onClose }) {
  const { t } = useTranslation();

  return (
    <RightDrawer
      open={open}
      onClose={onClose}
      eyebrow={t("offers.help.eyebrow")}
      title={t("offers.help.title")}
      width={480}
      footer={
        <div className="flex flex-wrap gap-x-4 gap-y-2">
          <DocLink href={DOCS.offer} label={t("offers.help.link_module")} />
          <DocLink
            href={DOCS.screenSpec}
            label={t("offers.help.link_screens")}
          />
        </div>
      }
    >
      <p className="mb-5 text-[13px] leading-relaxed text-slate-600">
        {t("offers.help.intro")}
      </p>

      <HelpSection title={t("offers.help.calc_vs_lines_title")}>
        <p>{t("offers.help.calc_vs_lines_body")}</p>
        <DocLink
          href={DOCS.calculations}
          label={t("offers.help.link_calculations")}
        />
      </HelpSection>

      <HelpSection title={t("offers.help.doc_vs_attachments_title")}>
        <p>{t("offers.help.doc_vs_attachments_body")}</p>
        <DocLink
          href={DOCS.documentStructure}
          label={t("offers.help.link_document")}
        />
      </HelpSection>

      <HelpSection title={t("offers.help.revisions_title")}>
        <p>{t("offers.help.revisions_body")}</p>
      </HelpSection>

      <HelpSection title={t("offers.help.grouping_title")}>
        <p>{t("offers.help.grouping_body")}</p>
      </HelpSection>
    </RightDrawer>
  );
}
